/**
 * Shared canvasser colouring rule.
 * Used by CanvasserPieChart and TurfCoverageList to keep canvasser colours
 * consistent: the top CANVASSER_TOP_N canvassers (by whatever contribution
 * metric the caller sorts by) get the viz.cat.1..N categorical colours; every
 * canvasser beyond that collapses into a single muted "Other" bucket
 * (viz.party.other) rather than cycling back through the palette.
 */

import { topNWithOther } from '../components/shared/viz/vizVars'

export const CANVASSER_TOP_N = 7

export function assignCanvasserColors<T>(items: T[]) {
  return topNWithOther(items, CANVASSER_TOP_N)
}
